import { DatePipe } from '@angular/common';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { HttpService } from 'src/app/service/http/http.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MatStepper } from '@angular/material/stepper';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ShowImagePopupComponent } from 'src/app/shared/popups/show-image-popup/show-image-popup.component';
import { ChooseColorPopupComponent } from 'src/app/shared/popups/choose-color-popup/choose-color-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { saveAs } from 'file-saver';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AccessMatrixDetailsPopupComponent } from 'src/app/shared/popups/access-matrix-details-popup/access-matrix-details-popup.component';

@Component({
  selector: 'app-admin-access-matrix',
  templateUrl: './admin-access-matrix.component.html',
  styleUrls: ['./admin-access-matrix.component.scss']
})
export class AdminAccessMatrixComponent implements OnInit {
  toggleshowSalaryDetails: boolean = false;
  gridData: {
    columnInfo: Array<{ label: string; propertyName: string; sortingName: string }>;
    columnData: Array<any>;
    totalCount: number;
    totalNoOfPages: number;
    showCheckBox: boolean;
    showExportBtn: boolean;
    showGraphBtn: boolean;
    showSearchBar: boolean;
    showAddBtn: boolean;
    currentPage: number;
    showDeleteBtn: boolean;
    tabsData: Array<any>;
    tabsMainData: Array<any>;
    showAccessConfigBtn: boolean;
    showTitle: boolean;
    showBreadCrumbs: boolean;
    showAuditLog: boolean;
    showPermantDeleteBtn: boolean;
    showRestoreBtn: boolean;
    showImportBtn: boolean;
    showBackBtn: boolean;
    showRefreshFunctinallity: boolean;
    countTabs: Array<any>;
  } = {
    columnInfo: [],
    columnData: [],
    totalCount: 0,
    totalNoOfPages: 0,
    showCheckBox: true,
    showExportBtn: true,
    showGraphBtn: false,
    showSearchBar: true,
    showAddBtn: true,
    currentPage: 0,
    showDeleteBtn: true,
    tabsData: [],
    tabsMainData: [],
    showAccessConfigBtn: false,
    showTitle: true,
    showBreadCrumbs: false,
    showAuditLog: false,
    showPermantDeleteBtn: false,
    showRestoreBtn: false,
    showImportBtn: false,
    showBackBtn: false,
    showRefreshFunctinallity: true,
    countTabs: []
  };
  isChangeDetected: boolean = false;
  paginationUrl: any = null;
  currentPage: number = 0;
  selectedSizeToShowData: number = 25;
  searchString: any = null;
  showAddPopup: boolean = false;
  showDetailsPopup: boolean = false;
  showListingPage: boolean = true;
  isEditModeactive: boolean = false;
  incidentForm: FormGroup = new FormGroup({});
  injuredBodyPartsDetailsArray: any = [];
  dashboardColorNameList: any = ['#F6921E', '#393186'];
  moduleList: any = [];
  maxDate: any;
  currentDate: any;
  tabs = [];

  editActivationFormOfCompFlag: boolean = false;
  isLinear = false;
  private subscription!: Subscription;
  collapseSidebar: boolean = false;
  @ViewChild('stepper')
  stepper!: MatStepper;
  modulesOfHRAdmin: any = [];
  fileName: any = null;
  fileType: any = null;
  uploadedFileUrl: any = '';
  uploadedContractUrl: any = '';
  loggedInUserId: any;
  companyData: any = [];
  industriesListData: any = [];
  subIndustriesList: any = [];
  formSubmitted: boolean = false;
  compStatus: any;
  serialNumberOfComp: any;
  loggedInUserRole: any;
  minDate: any;
  loggedInUserCompanyID: any;
  locationListOfCompany: any = [];
  bandListOfCompany: any = [];
  DeptListOfCompany: any = [];
  DesListOfCompany: any = [];
  employeeListOfCompany: any = [];
  designation: any = [];
  officeLocation: any = [];
  band: any = [];
  department: any = [];
  employee: any = [];
  employeeList: any = [];
  selectedEmployees: any = [];
  getAllEmployeeofCompany: any = [];
  selectedAdminEmployee: any = null;
  accessMatrixID: any = null;
  acessModules: any = [];
  buttonColorName: any;
  subModuleButtonColor: any;
  dropdownSettings: IDropdownSettings = {};
  companyHrId: any;
  operation: any;
  constructor(
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private activatedroute: ActivatedRoute,
    private sharedService: SharedService,
    private renderer: Renderer2,
    private loader: LoaderService,
    private encyptDecryptData: EncryptionService
  ) {}

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');

    this.loggedInUserCompanyID = Number(this.encyptDecryptData.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encyptDecryptData.decryptData(this.loggedInUserRole);
    }
    this.initilaizeColumn();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }
  ionViewWillEnter() {
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encyptDecryptData.decryptData(this.loggedInUserRole);
    }
    this.minDate = new Date();
    this.showAddPopup = false;
    this.showDetailsPopup = false;
    this.isEditModeactive = false;
    this.showListingPage = true;
    this.formSubmitted = false;
    this.editActivationFormOfCompFlag = false;
    this.currentDate = new Date().toISOString();
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Add') {
        this.operation = 'Add';
        this.showAddPopup = true;
        this.showDetailsPopup = false;
        this.isEditModeactive = false;
        this.showListingPage = false;
        this.selectedAdminEmployee = null;
        this.officeLocation = [];
        this.band = [];
        this.department = [];
        this.designation = [];
        this.selectedEmployees = [];
        this.getLocationList();
        // this.getBandList();
        // this.getDepartmentList();
        // this.getDesignationList();
        this.getCompanyDataByCompID();
      } else if (params?.operation == 'Edit') {
        this.operation = 'Edit';
        this.accessMatrixID = params?.id;
        this.showAddPopup = true;
        this.showDetailsPopup = false;
        this.isEditModeactive = true;
        this.showListingPage = false;
        this.getCompanyDataByCompID();
      } else if (params?.operation == 'Show') {
        this.operation = 'Show';
        this.accessMatrixID = params?.id;
        this.showAddPopup = false;
        this.showDetailsPopup = true;
        this.isEditModeactive = false;
        this.showListingPage = false;
      } else {
        if (this.loggedInUserRole == 'Admin') {
          this.gridData.showCheckBox = false;
          this.gridData.showAddBtn = false;
          this.gridData.showImportBtn = false;
          this.gridData.showExportBtn = false;
        } else {
          this.gridData.showCheckBox = true;
          this.gridData.showAddBtn = true;
          this.gridData.showImportBtn = false;
          this.gridData.showExportBtn = true;
        }
        this.showAddPopup = false;
        this.showDetailsPopup = false;
        this.isEditModeactive = false;
        this.showListingPage = true;
        this.getAllAccessMatrix();
      }
    });
  }

  initilaizeColumn() {
    this.gridData.columnInfo = [];
    this.gridData.columnInfo.push({ label: 'Employee Name', propertyName: 'empName', sortingName: 'firstName' });
    this.gridData.columnInfo.push({ label: 'Empl Salary Hide/Show', propertyName: 'checkSalaryDetailsView', sortingName: 'checkSalaryDetailsView' });
    this.gridData.columnInfo.push({ label: 'Modules', propertyName: 'modules', sortingName: 'modules.moduleName' });
    this.gridData.columnInfo.push({ label: 'Access', propertyName: 'viewDetails', sortingName: 'id' });
    if (this.loggedInUserRole != 'Admin') {
      this.gridData.columnInfo.push({ label: 'Action', propertyName: 'action', sortingName: 'action' });
    }
  }
  renderData(listData: any) {
    let cnt = this.gridData.currentPage * 25;
    console.log(listData);

    this.gridData.columnData = [];
    if (this.loggedInUserRole != 'Admin') {
      for (let i = 0; i < listData?.length; i++) {
        this.gridData.columnData.push({
          id: listData[i].id,
          empName: listData[i].firstName + ' ' + listData[i].lastName,
          checkSalaryDetailsView: listData[i].checkSalaryDetailsView ? 'Show' : 'Hide',
          modules: listData[i].modules,
          viewDetails: listData[i],
          action: 'edit'
        });
      }
    } else {
      for (let i = 0; i < listData?.length; i++) {
        this.gridData.columnData.push({
          id: listData[i].id,
          empName: listData[i].firstName + ' ' + listData[i].lastName,
          checkSalaryDetailsView: listData[i].checkSalaryDetailsView ? 'Show' : 'Hide',
          modules: listData[i].modules,
          viewDetails: listData[i]
        });
      }
    }
    this.isChangeDetected = !this.isChangeDetected;
  }
  transform(value: string): string {
    switch (value) {
      case 'OnBoardingPending':
        return 'On-Boarding Pending';
      case 'Active':
        return 'Active';
      case 'Inactive':
        return 'Inactive';
      case 'Jan_Dec':
        return 'Jan-Dec';
      case 'Apr_Mar':
        return 'Apr-Mar';
      case 'July_Jun':
        return 'July-Jun';
      case 'Oct_Sep':
        return 'Oct-Sep';
      default:
        return value;
    }
  }
  typeTabChnage(data: any) {}
  deleteMultipleRecord(deleteData: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Do you really want to delete these record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // let id: any[] = [];
        // for (let i = 0; i < deleteData.length; i++) {
        //   id.push(deleteData[i].find((item: any) => item.key == 'id').value);
        // }
        const id = deleteData.map((item: any) => item.id);

        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.multiSoftDeleteAccessMatrix, { isDeleted: true, id: id }).subscribe(
          (res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: res.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getAllAccessMatrix();
            });
          },
          (err: any) => {
            this.loader.dismissLoader();
            console.log(err);
          }
        );
      }
    });
  }
  pageNavigation(response: any) {
    this.currentPage = response.currentPageNumber - 1;
    this.renderData(response.data.plant);
  }
  backBtn() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Are you sure you want to leave this page?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/home/hrportal/accessmatrix']);
      }
    });
  }

  addRecord() {
    this.router.navigate(['/home/hrportal/accessmatrix', { id: 0, operation: 'Add' }]);
  }
  editRecord(data: any) {
    let id = data.find((item: any) => item.key == 'id').value;
    this.router.navigate(['/home/hrportal/accessmatrix', { id: id, operation: 'Edit' }]);
  }

  getEmpAccessData = [];
  getAllAccessMatrix() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchString,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe(
      (data: any) => {
        this.loader.dismissLoader();
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data.access);
        this.getEmpAccessData = data.data;
      },
      (error: any) => {},
      () => {}
    );
  }
  sortAsending(data: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchString,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.searchAccess + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',asc', request).subscribe(
      (data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data.access);
      },
      (error: any) => {},
      () => {}
    );
  }
  sortDesending(data: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchString,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.searchAccess + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',desc', request).subscribe(
      (data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data.access);
      },
      (error: any) => {},
      () => {}
    );
  }
  pageChange(data: any) {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchString,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.searchAccess + '?page=' + data + '&size=' + this.selectedSizeToShowData, request).subscribe(
      (data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data.access);
      },
      (error: any) => {},
      () => {}
    );
  }
  onSelectSizeData(size: any) {
    this.selectedSizeToShowData = size;
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchString,
      loggedInUserRole: this.loggedInUserRole
    };
    this.httpService.callPostService(this.config.searchAccess + '?page=' + 0 + '&size=' + this.selectedSizeToShowData, request).subscribe(
      (data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data.access);
      },
      (error: any) => {},
      () => {}
    );
  }
  searchData(data: any) {
    var search = '';
    this.searchString = data;
    if (data == '') {
      this.searchString = null;
      this.getAllAccessMatrix();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            const request = {
              companyId: this.loggedInUserCompanyID,
              search: this.searchString,
              loggedInUserRole: this.loggedInUserRole
            };
            this.httpService.callPostService(this.config.searchAccess + '?sort=id' + ',asc', request).subscribe(
              (data: any) => {
                this.currentPage = 0;
                this.gridData.totalNoOfPages = data.data?.totalPages;
                this.gridData.totalCount = data.data?.total;
                this.gridData.currentPage = data.data?.currentPageNumber;
                this.renderData(data.data.access);
              },
              (error: any) => {},
              () => {}
            );
          }, 500);
        }
      }, 1500);
    }
  }
  refreshData() {
    this.searchString = null;
    this.gridData.currentPage = 0;
    this.selectedSizeToShowData = 25;
    this.currentPage = 0;
    this.loader.simpleLoaderWithDuration();
    this.getAllAccessMatrix();
  }
  exportReport(selectedIds: any) {
    let id: any[] = [];
    if (selectedIds.length != 0) {
      id.push(selectedIds.find((item: any) => item.key == 'id')?.value);
    } else {
      id = [];
    }
    const request = {
      companyId: this.loggedInUserCompanyID,
      id: id
    };
    this.httpService.callPostService(this.config.downloadAccessMatrix, request).subscribe(
      (data: any) => {
        saveAs(data?.fileUrl, 'AdminAccessMatrixData');
      },
      (error: any) => {},
      () => {}
    );
  }
  showDatails(data: any) {
    // console.log('this.getEmpAccessData - - - ', this.getEmpAccessData);
    // console.log('data - - - ', data);
    const idObj = data.find((item: any) => item.key === 'id');
    const id = idObj ? idObj.value : null;
    const viewDetails = data.find((item: any) => item.key === 'viewDetails')?.value;

    const dialogRef = this.dialog.open(AccessMatrixDetailsPopupComponent, {
      maxWidth: '992px',
      panelClass: ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'],
      data: {
        popupName: 'Access',
        data: viewDetails
      }
    });
  }
  deleteRecords(data: any) {}

  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      this.acessModules = [];
      this.companyHrId = data?.data?.companyHrId;
      data?.data?.modules?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          moduleName: ele.moduleName,
          isChecked: false,
          isDisabled: false
        };
        this.acessModules.push(obj);
      });
      this.getAllEmployeeDropdownByCompanyID();
    });
  }

  getLocationList() {
    this.httpService.callGetService(this.config.getLocationList + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.locationListOfCompany = [];

      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.locationListOfCompany.push(obj);
      });
      this.locationListOfCompany = this.locationListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
      console.log(this.officeLocation);
      console.log(this.getBand);

      this.getBandList();
    });
  }
  getBandList() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      officeLocation: this.officeLocation?.map((ele: { id: any }) => ele.id)
    };
    this.httpService.callPostService(this.config.dwmGetGradeListByLocation, request).subscribe((data: any) => {
      this.bandListOfCompany = [];
      this.band = [];
      this.department = [];
      this.designation = [];
      this.selectedEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.bandListOfCompany.push(obj);
      });
      this.bandListOfCompany = this.bandListOfCompany?.sort((a: any, b: any) => a?.name?.localeCompare(b?.name));

      let checkband = this.bandListOfCompany.filter((elm: any) => this.getBand.includes(elm.id) || this.getBand.includes(elm.name));

      (checkband || []).forEach((ele: any) => {
        const obj = {
          id: ele.id,
          name: ele.name
          // ✅ true if present in company list
        };
        console.log(obj);

        this.band?.push(obj);
      });
      this.getDepartmentList();
    });
  }
  getDepartmentList() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      grade: this.band?.map((ele: { id: any }) => ele.id)
    };
    this.httpService.callPostService(this.config.dwmGetDepartmentListByGrade, request).subscribe((data: any) => {
      this.DeptListOfCompany = [];
      this.department = [];
      this.designation = [];
      this.selectedEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.DeptListOfCompany.push(obj);
      });
      this.DeptListOfCompany = this.DeptListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));

      let checkDept = this.DeptListOfCompany.filter((elm: any) => this.getDept.includes(elm.id) || this.getDept.includes(elm.name));
      checkDept?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.name
        };
        this.department?.push(obj);
      });
      this.getDesignationList();
    });
  }
  getDesignationList() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      department: this.department?.map((ele: { id: any }) => ele.id)
    };
    this.httpService.callPostService(this.config.getDesignationListByDepartment, request).subscribe((data: any) => {
      this.DesListOfCompany = [];
      this.designation = [];
      this.selectedEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        };
        this.DesListOfCompany.push(obj);
      });
      this.DesListOfCompany = this.DesListOfCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
      let checkDesignation = this.DesListOfCompany?.filter((elm: any) => this.getDesignation?.includes(elm.id) || this.getDesignation?.includes(elm.name));

      // initialize array if not already
      this.designation = this.designation || [];

      // push matched ones
      checkDesignation?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.name
        };
        this.designation.push(obj);
      });

      this.getEmployeeList();
    });
  }

  getEmployeeList() {
    const request = {
      grade: this.band?.map((ele: { id: any }) => ele.id),
      companyId: this.loggedInUserCompanyID,
      department: this.department?.map((ele: { id: any }) => ele.id),
      designation: this.designation?.map((ele: { id: any }) => ele.id),
      officeLocation: this.officeLocation?.map((ele: { id: any }) => ele.id)
    };
    this.httpService.callPostService(this.config.dwmGetGetUsersList, request).subscribe((data: any) => {
      this.employeeList = [];
      this.selectedEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.employeeList.push(obj);
      });
      this.employeeList = this.employeeList.sort((a: any, b: any) => a.name.localeCompare(b.name));

      let manageIds = this.getEmp.map((ele: any) => ele.employeeId);

      let checkEmp = this.employeeList.filter((elm: any) => manageIds.includes(elm.id));

      checkEmp.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.name
        };
        this.selectedEmployees?.push(obj);
      });
    });
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: null
    };
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request).subscribe(
      (data: any) => {
        this.getAllEmployeeofCompany = [];
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          };
          this.getAllEmployeeofCompany.push(obj);
        });
        this.getAllEmployeeofCompany = this.getAllEmployeeofCompany.filter((item: { id: number }) => item.id != this.companyHrId);
        this.getAllEmployeeofCompany = this.getAllEmployeeofCompany.sort((a: any, b: any) => a.name.localeCompare(b.name));
        if (this.operation == 'Edit') {
          this.getAccessMatrixDataById();
        }
      },
      (error: any) => {},
      () => {}
    );
  }
  selectedModuleList: any = [];
  onCheckModuleAccess(event: any, i: any, data: any) {
    if (event.checked) {
      this.acessModules[i].isChecked = true;
      this.selectedModuleList.push(data);
    } else {
      this.acessModules[i].isChecked = false;

      this.selectedModuleList.forEach((ele: any, ind: any) => {
        if (data.moduleName == ele.moduleName) {
          if (data.isChecked == false) {
            this.selectedModuleList.splice(ind, 1);
          }
        }
      });
    }
  }
  onClickSaveAccesMatrix() {
    this.formSubmitted = true;
    var flag = true;
    if (this.selectedAdminEmployee == null) {
      flag = false;
    }
    if (this.officeLocation.length == 0) {
      flag = false;
    }
    if (this.band.length == 0) {
      flag = false;
    }
    if (this.department.length == 0) {
      flag = false;
    }
    if (this.designation.length == 0) {
      flag = false;
    }
    if (this.selectedEmployees.length == 0) {
      flag = false;
    }
    if (this.selectedModuleList.length == 0) {
      flag = false;
    }
    var moduleIds: any[] = [];
    this.selectedModuleList.forEach((ele: any) => {
      if (ele.isDisabled == false) {
        moduleIds.push(ele.id);
      }
    });
    if (moduleIds.length == 0) {
      flag = false;
    }
    if (flag) {
      this.formSubmitted = false;
      const request = {
        band: this.band?.map((ele: { id: any }) => ele.id),
        companyId: this.loggedInUserCompanyID,
        department: this.department?.map((ele: { id: any }) => ele.id),
        designation: this.designation?.map((ele: { id: any }) => ele.id),
        locations: this.officeLocation?.map((ele: { id: any }) => ele.id),
        employee: this.selectedEmployees.map((ele: { id: any }) => ele.id),
        employeeId: this.selectedAdminEmployee,
        id: this.accessMatrixID,
        moduleId: moduleIds,
        checkSalaryDetailsView: this.toggleshowSalaryDetails
      };
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.addAccessMatrix, request).subscribe(
        (data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/home/hrportal/accessmatrix']);
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });
            successdialogRef.afterClosed().subscribe(result => {});
          }
        },
        (error: any) => {
          this.loader.dismissLoader();
        },
        () => {}
      );
    }
  }
  getBand: any;
  getDept: any;
  getDesignation: any;
  getEmp: any;
  getAccessMatrixDataById() {
    this.httpService.callGetService(this.config.getAccessMatrixById + this.accessMatrixID).subscribe(
      async (data: any) => {
        this.selectedModuleList = [];
        this.officeLocation = [];
        this.designation = [];
        this.band = [];
        this.department = [];
        this.selectedEmployees = [];
        this.selectedAdminEmployee = data?.data?.employeeId;
        this.getBand = data?.data?.band;
        this.getDept = data?.data?.department;
        this.getDesignation = data?.data?.designation;
        this.getEmp = data?.data?.employeeDetails;

        this.toggleshowSalaryDetails = data?.data?.checkSalaryDetailsView ? data?.data?.checkSalaryDetailsView : false;

        data?.data?.locations?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele
          };
          this.officeLocation.push(obj);
        });
        // this.band = [];

        // (data?.data?.band || []).forEach((ele: any) => {
        //   const obj = {
        //     id: ele,
        //     name: ele,
        //     checked: this.bandListOfCompany.includes(ele)   // ✅ true if present in company list
        //   };
        //   this.band.push(obj);
        // });

        // data?.data?.department?.forEach((ele: any) => {
        //   let obj = {
        //     id: ele,
        //     name: ele
        //   }
        //   this.department.push(obj);
        // });
        // data?.data?.designation?.forEach((ele: any) => {
        //   let obj = {
        //     id: ele,
        //     name: ele
        //   }
        //   this.designation.push(obj);
        // });
        // this.selectedEmployees = [];
        // data?.data?.employeeDetails?.forEach((ele: any) => {
        //   let obj = {
        //     id: ele.employeeId,
        //     name: ele.firstName + ' ' + ele.lastName,
        //   }
        //   this.selectedEmployees.push(obj)
        // })
        data?.data?.modules?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            moduleName: ele.moduleName,
            isChecked: true,
            isDisabled: false
          };
          this.selectedModuleList.push(obj);
        });
        this.toCheckGetModuleAccessToAdminByEmpID();
        setTimeout(() => {
          data?.data?.modules?.forEach((selectedValue: { id: any }) => {
            const item = this.acessModules.find((value: { id: any }) => value.id === selectedValue.id);
            if (item) {
              item.isChecked = true;
            }
          });
          for (let i = 0; i < this.toCheckCommonAccessModule.length; i++) {
            for (let k = 0; k < this.acessModules.length; k++) {
              if (this.toCheckCommonAccessModule[i].id == this.acessModules[k].id) {
                this.acessModules[k].isDisabled = true;
                this.acessModules[k].isChecked = true;
              }
            }
          }
          for (let j = 0; j < data?.data?.modules?.length; j++) {
            for (let k = 0; k < this.acessModules.length; k++) {
              if (data?.data?.modules[j].id == this.acessModules[k].id) {
                this.acessModules[k].isDisabled = false;
              }
            }
          }
          this.getLocationList();
          // this.getBandList();
          // this.getDepartmentList();
          // this.getDesignationList();
          // this.getEmployeeList();
        }, 2000);
        // this.getSelectedEmployeeList(data?.data);
      },
      (error: any) => {},
      () => {}
    );
  }
  getSelectedEmployeeList(data1: any) {
    const request = {
      band: this.band,
      companyId: this.loggedInUserCompanyID,
      department: this.department,
      designation: this.designation,
      officeLocation: this.officeLocation
    };
    this.httpService.callPostService(this.config.getEmployeeList, request).subscribe((data: any) => {
      this.employeeList = [];
      this.selectedEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          name: ele.firstName + ' ' + ele.lastName
        };
        this.employeeList.push(obj);
      });
      this.employeeList = this.employeeList.sort((a: any, b: any) => a.name.localeCompare(b.name));
      for (let i = 0; i < data1?.employeeDetails?.length; i++) {
        this.selectedEmployees.push(data1?.employeeDetails[i].employeeId);
      }
    });
  }
  getEmployeeList11() {
    console.log(this.selectedEmployees);
  }
  selectAllLocation(items: any): void {
    this.officeLocation = items;
    this.getBandList();
  }
  onDeSelectAllLocation() {
    this.officeLocation = [];
    this.band = [];
    this.department = [];
    this.designation = [];
    this.selectedEmployees = [];
    this.bandListOfCompany = [];
    this.DeptListOfCompany = [];
    this.DesListOfCompany = [];
    this.employeeList = [];
  }
  selectAllBand(items: any): void {
    this.band = items;
    this.getDepartmentList();
  }
  onDeSelectAllBand() {
    this.band = [];
    this.department = [];
    this.designation = [];
    this.selectedEmployees = [];
    this.DeptListOfCompany = [];
    this.DesListOfCompany = [];
    this.employeeList = [];
  }
  selectAllDept(items: any): void {
    this.department = items;
    this.getDesignationList();
  }
  onDeSelectAllDept() {
    this.department = [];
    this.designation = [];
    this.selectedEmployees = [];
    this.DesListOfCompany = [];
    this.employeeList = [];
  }
  selectAllDeg(items: any): void {
    this.designation = items;
    this.getEmployeeList();
  }
  onDeSelectAllDeg() {
    this.designation = [];
    this.selectedEmployees = [];
    this.employeeList = [];
  }
  selectAllEmp(items: any): void {
    this.selectedEmployees = items;
  }
  onDeSelectAllEmp() {
    this.selectedEmployees = [];
  }
  changeGetCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      this.acessModules = [];
      this.companyHrId = data?.data?.companyHrId;
      data?.data?.modules?.forEach((ele: any) => {
        let obj = {
          id: ele.id,
          moduleName: ele.moduleName,
          isChecked: false,
          isDisabled: false
        };
        this.acessModules.push(obj);
      });
      this.getModuleAccessToAdminByEmpID();
    });
  }
  toCheckCommonAccessModule: any = [];
  async toCheckGetModuleAccessToAdminByEmpID() {
    this.httpService.callGetService(this.config.getModuleAccessToAdminByEmpID + this.selectedAdminEmployee).subscribe(
      (data: any) => {
        this.toCheckCommonAccessModule = [];
        data?.data?.modules?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            moduleName: ele.moduleName,
            isChecked: true,
            isDisabled: true
          };
          this.toCheckCommonAccessModule.push(obj);
        });
      },
      (error: any) => {},
      () => {}
    );
  }
  getModuleAccessToAdminByEmpID() {
    this.httpService.callGetService(this.config.getModuleAccessToAdminByEmpID + this.selectedAdminEmployee).subscribe(
      (data: any) => {
        data?.data?.modules?.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            moduleName: ele.moduleName,
            isChecked: true,
            isDisabled: true
          };
          this.selectedModuleList.push(obj);
        });

        data?.data?.modules?.forEach((selectedValue: { id: any }) => {
          const item = this.acessModules.find((value: { id: any }) => value.id === selectedValue.id);
          if (item) {
            if (this.operation == 'Add') {
              item.isDisabled = true;
            }
            item.isChecked = true;
          }
        });
        this.getBandList();
        this.getDepartmentList();
        this.getDesignationList();
        this.getEmployeeList();
      },
      (error: any) => {},
      () => {}
    );
  }
}
